import { createSlice } from "@reduxjs/toolkit";

export const eocHistorySlice = createSlice({
    name: 'eocHistory',
    initialState: {
        value: undefined
    },
    reducers: {
        setEOCHistory: (state, action) => {
            state.value = action.payload;
        }
    }
})

export const { setEOCHistory } = eocHistorySlice.actions;

export const getEOCHistory = (state) => state.eocHistory.value;

export default eocHistorySlice.reducer;